import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography,
} from "@mui/material";
import SystemAdmins from "./SystemAdmins";
import PortalAdmins from "./PortalAdmins";

type MenuKey = "platform" | "portal";

interface MenuEntry {
  key: MenuKey;
  label: string;
  emoji: string;
}

const MENU: MenuEntry[] = [
  { key: "platform", label: "Platform Admins", emoji: "🛡" },
  { key: "portal", label: "Portal Admins", emoji: "👥" },
];

const Users: React.FC = () => {
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get("tab") === "portal" ? "portal" : "platform";
  const [active, setActive] = useState<MenuKey>(initialTab);

  return (
    <Box sx={{ p: 3 }}>
      <Box
        sx={{
          mb: 3,
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 800, mb: 0.5 }}>
          Users
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Manage platform and portal administrators.
        </Typography>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "260px 1fr" },
          gap: 3,
          alignItems: "start",
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: 1,
            border: "1px solid",
            borderColor: "divider",
            bgcolor: "background.paper",
          }}
        >
          <Typography
            variant="overline"
            sx={{
              px: 2,
              pt: 1.5,
              pb: 1,
              display: "block",
              color: "text.secondary",
              fontWeight: 700,
              letterSpacing: "0.12em",
            }}
          >
            Admins
          </Typography>
          <List disablePadding>
            {MENU.map((item) => {
              const selected = active === item.key;
              return (
                <ListItemButton
                  key={item.key}
                  selected={selected}
                  onClick={() => setActive(item.key)}
                  sx={{ py: 1 }}
                >
                  <ListItemIcon sx={{ minWidth: 34, fontSize: 18 }}>
                    {item.emoji}
                  </ListItemIcon>
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      fontWeight: 600,
                      fontSize: "0.9rem",
                    }}
                  />
                </ListItemButton>
              );
            })}
          </List>
        </Paper>

        <Box sx={{ minWidth: 0 }}>
          {active === "platform" && <SystemAdmins />}
          {active === "portal" && <PortalAdmins />}
        </Box>
      </Box>
    </Box>
  );
};

export default Users;
